import React, { FC } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type Props = {
  className?: string;
  email: string;
};

export const UserIcon: FC<Props> = ({ email, className = "" }) => {
  return (
    <OverlayTrigger
      container={document.body}
      delay={{ show: 200, hide: 100 }}
      popperConfig={{ strategy: "fixed" }}
      placement="bottom"
      overlay={<Tooltip>{email}</Tooltip>}
    >
      <div
        className={`d-flex justify-content-center align-items-center cursor-default user-icon ${className}`}
      >
        <span className="text-uppercase text-white">{email?.slice(0, 1)}</span>
      </div>
    </OverlayTrigger>
  );
};
